import { CustomCheckbox } from '@atbay/component-lib'
import { CloseIcon, RecurringIcon } from '@atbay/icons'
import { FC } from 'react'
import { Body, DomainRow, DomainsWrapper } from './domainDiscovery.styles'
import { TDomainDiscoveryProps } from './domainDiscovery.types'

const DomainDiscovery: FC<TDomainDiscoveryProps> = ({
    handleOnDomainChange,
    handleOnDomainDiscoveryDeleted,
    handleOnDomainDiscoveryRestore,
    domainDiscoveryDomainsArray,
}) => {
    if (domainDiscoveryDomainsArray.length === 0) {
        return null
    }

    return (
        <Body>
            <p className="note">
                We've identified domains potentially linked to your
                organization. Please select the ones truly relevant for tailored
                security insights.
            </p>
            <DomainsWrapper>
                {domainDiscoveryDomainsArray.map(
                    ({ id, domain_url: url, checked, deleted }) => (
                        <DomainRow
                            key={id}
                            className={deleted ? 'deleted' : ''}
                        >
                            <CustomCheckbox
                                key={id}
                                checked={checked}
                                disabled={deleted}
                                label={url}
                                accessibilityId="domain-discovery"
                                onChange={(_, checked) =>
                                    handleOnDomainChange(id, checked)
                                }
                            />
                            {deleted ? (
                                <span
                                    className="restore-icon"
                                    data-testid="restore-icon"
                                >
                                    <RecurringIcon
                                        onClick={() =>
                                            handleOnDomainDiscoveryRestore(id)
                                        }
                                    />
                                </span>
                            ) : (
                                !checked && (
                                    <span
                                        className="close-icon"
                                        data-testid="close-icon"
                                    >
                                        <CloseIcon
                                            onClick={() =>
                                                handleOnDomainDiscoveryDeleted(
                                                    id
                                                )
                                            }
                                        />
                                    </span>
                                )
                            )}
                        </DomainRow>
                    )
                )}
            </DomainsWrapper>
        </Body>
    )
}

export default DomainDiscovery
